import axios from 'axios'
import cookie from 'react-cookies'
import imageCompression from 'browser-image-compression'
import { notify } from 'react-notify-toast'
import ApiURL from './ApiUrl'
import createAuthRefreshInterceptor from 'axios-auth-refresh'

export const getUserAuthData = async () => {
  let userData

  await axios
    .get(`${ApiURL}/api/auth/users/me`, {
      headers: {
        Authorization: 'Bearer ' + cookie.load('accessToken'), //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.data) {
        userData = response.data
      }
    })

    // return userData

    .catch((error) => {
      console.log(error)
    })

  return userData
}

export const getUserMissingSteps = async () => {
  let missingSteps

  await axios
    .get(`${ApiURL}/api/auth/users/missing_steps`, {
      headers: {
        Authorization: 'Bearer ' + cookie.load('accessToken'), //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response?.data) {
        missingSteps = response.data

        return missingSteps
      }
    })

    // return userData

    .catch((error) => {
      console.log(error)
    })
}
